module.exports = __webpack_public_path__ + "img/straight-rail-vertical-ties-remnants.301be32e.png";